import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './AllDepartments.css';
import ClearFilter from '../../components/ClearFilter';
import useDepartments from '../../hooks/useDepartments';
import useCourses from '../../hooks/useCourses';
import { apiFetch } from '../../utils/api';
import Statistics from '../../images/Statistics.jpg';
import Sqlimage from '../../images/Sqlimage.jpg';
import salesforce from '../../images/salesforce.png';
import productengineeringandservices from '../../images/productengineeringandservices.png';
import H1BSTAFF from '../../images/H1BSTAFF.png';
import erp from '../../images/erp.png';
import entierpriseandarchitecture from '../../images/entierpriseandarchitecture.png';
import datascienceandai from '../../images/datascienceandai.png';
import machinelearning from '../../images/machinelearning.jpg';
import azure from '../../images/azure.jpg';
import aws from '../../images/aws.jpg';
import airflow from '../../images/airflow.jpg';
import dbt from '../../images/dbt.jpg';
import deeplearning from '../../images/deeplearning.jpg';
import kafka from '../../images/kafka.jpg';
import gcp from '../../images/gcp.jpg';
import tableau from '../../images/tableau.jpg';
import pyspark from '../../images/pyspark.jpg';
import r from '../../images/r.jpg';
import matplotlib from '../../images/matplotlib.jpg';
import pandas from '../../images/pandas.jpg';
import hadoop from '../../images/hadoop.jpg';
import numpy from '../../images/numpy.jpg';
import oci from '../../images/oci.jpg';
import automation from '../../images/automation.jpg';
import springboot from '../../images/springboot.jpg';
import react from '../../images/react.jpg';
import mulesoft from '../../images/mulesoft.jpg';
import kubernetes from '../../images/kubernetes.png';
import java from '../../images/java.jpg';
import javascript from '../../images/javascript.jpg';
import django from '../../images/django.jpg';
import angular from '../../images/angular.jpg';
import course1 from '../../images/course1.jpg';

const AllDepartments = () => {
  const { departments, loading, error } = useDepartments();
  const { courses } = useCourses();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [courseSearchQuery, setCourseSearchQuery] = useState('');
  const [enrolledCourses, setEnrolledCourses] = useState([]);

  const getCourseId = (course) => course?.id ?? course?.course_id;

  React.useEffect(() => {
    const fetchEnrolledCourses = async () => {
      try {
        const userEmail = localStorage.getItem('userEmail');
        if (!userEmail) return;

        const userInfo = await apiFetch(`${window._env_.API_BASE_URL}/users/info?email=${userEmail}`);
        const enrolledList = await apiFetch(`${window._env_.API_BASE_URL}/users/${userInfo.user_id}/courses`);
        const enrolledIds = enrolledList.map((course) => course.course_id);
        setEnrolledCourses(enrolledIds);
      } catch (error) {
        console.error('Error fetching enrolled courses:', error);
      }
    };

    fetchEnrolledCourses();
  }, []);

  // Clear search query
  const handleClearFilters = () => {
    setSearchQuery('');
    setCourseSearchQuery('');
  };

  const getCourseImage = (imageName) => {
    const imageMap = {
      'course1.jpg': course1,
      'course2.jpg': course1,
      'course3.jpg': course1,
      'statistics.png': Statistics,
      'sqlimage.png': Sqlimage,
      'salesforce.png': salesforce,
      'productengineeringandservices.png': productengineeringandservices,
      'H1BSTAFF.png': H1BSTAFF,
      'erp.png': erp,
      'entierpriseandarchitecture.png': entierpriseandarchitecture,
      'datascienceandai.png': datascienceandai,
      'machinelearning.jpg': machinelearning,
      'airflow.jpg': airflow,
      'aws.jpg': aws,
      'azure.jpg': azure,
      'gcp.jpg': gcp,
      'deeplearning.jpg': deeplearning,
      'kafka.jpg': kafka,
      'tableau.jpg': tableau,
      'pyspark.jpg': pyspark,
      'dbt.jpg': dbt,
      'matplotlib.jpg': matplotlib,
      'r.jpg': r,
      'pandas.jpg': pandas,
      'hadoop.jpg': hadoop,
      'automation.jpg': automation,
      'oci.jpg': oci,
      'numpy.jpg': numpy,
      'angular.jpg': angular,
      'springboot.jpg': springboot,
      'react.jpg': react,
      'mulesoft.jpg': mulesoft,
      'kubernetes.png': kubernetes,
      'java.jpg': java,
      'javascript.jpg': javascript,
      'django.jpg': django
    };
    return imageMap[imageName] || course1;
  };

  // Helper: show snackbar-style popup
  const showSnackbar = (message, backgroundColor = '#4CAF50') => {
    const snackbar = document.createElement('div');
    snackbar.textContent = message;
    snackbar.style.cssText =
      `position: fixed;
       top: 20px;
       left: 50%;
       transform: translateX(-50%);
       background-color: ${backgroundColor};
       color: white;
       padding: 12px 24px;
       border-radius: 4px;
       z-index: 1000;`;
    document.body.appendChild(snackbar);
    setTimeout(() => snackbar.remove(), 3000);
  };

  const handleEnroll = async (courseId) => {
    try {
      const userEmail = localStorage.getItem('userEmail');
      if (!userEmail) {
        navigate('/login');
        return;
      }

      const userInfo = await apiFetch(`${window._env_.API_BASE_URL}/users/info?email=${userEmail}`);
      const userId = userInfo.user_id;

      try {
        await apiFetch(`${window._env_.API_BASE_URL}/users/${userId}/enroll`, {
          method: 'POST',
          body: JSON.stringify({ course_id: courseId }),
        });
      } catch (error) {
        if (error.message && error.message.includes('already enrolled')) {
          showSnackbar('Already enrolled in the course', '#f44336');
        } else {
          alert(`Enrollment failed: ${error.message}`);
        }
        return;
      }

      // Update local state
      setEnrolledCourses(prev => (prev.includes(courseId) ? prev : [...prev, courseId]));

      // Success snackbar + navigate to course videos
      const snackbar = document.createElement('div');
      snackbar.textContent = 'Successfully enrolled in the course';
      snackbar.style.cssText =
        'position: fixed; top: 20px; left: 50%; transform: translateX(-50%); background-color: #4CAF50; color: white; padding: 12px 24px; border-radius: 4px; z-index: 1000;';
      document.body.appendChild(snackbar);

      setTimeout(() => {
        snackbar.remove();
        const course = filteredCourses.find((c) => getCourseId(c) === courseId);
        navigate('/course-videos', {
          state: {
            department: course?.department || course?.department_name,
            courseId,
            courseTitle: course?.title || course?.course_title
          }
        });
      }, 3000);
    } catch (error) {
      console.error('Enrollment error:', error);
      alert('An error occurred during enrollment. Please try again.');
    }
  };

  // Filter departments based on search query
  const filteredDepartments = departments.filter(dept => {
    const query = searchQuery.toLowerCase();
    return (
      dept.name.toLowerCase().includes(query) ||
      dept.description.toLowerCase().includes(query)
    );
  });

  // Filter courses based on course search query
  const filteredCourses = courses.filter(course => {
    const query = courseSearchQuery.toLowerCase();
    return (
      course.title.toLowerCase().includes(query) ||
      course.description.toLowerCase().includes(query) ||
      course.category.toLowerCase().includes(query)
    );
  });

  const handleUnenroll = async (course) => {
    try {
      const userEmail = localStorage.getItem('userEmail');
      if (!userEmail) {
        navigate('/login');
        return;
      }

      const courseId = getCourseId(course);
      if (!courseId) {
        throw new Error('Course ID is missing');
      }

      const userInfo = await apiFetch(`${window._env_.API_BASE_URL}/users/info?email=${userEmail}`);
      await apiFetch(
        `${window._env_.API_BASE_URL}/users/unenroll?user_id=${userInfo.user_id}&course_id=${courseId}`,
        { method: 'DELETE' }
      );

      setEnrolledCourses(prev => prev.filter(id => id !== courseId));
      showSnackbar('Successfully unenrolled from the course', '#f44336');
    } catch (error) {
      console.error('Unenroll error:', error);
      alert('An error occurred while unenrolling. Please try again.');
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleCourseSearchChange = (e) => {
    setCourseSearchQuery(e.target.value);
  };

  if (loading) {
    return (
      <div className="all-departments">
        <h1>All Departments</h1>
        <p>Explore courses by department to enhance your skills in specific areas.</p>
        <div className="search-filters-container">
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search departments..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
          <div className="course-search-bar">
            <input
              type="text"
              placeholder="Search courses..."
              value={courseSearchQuery}
              onChange={handleCourseSearchChange}
            />
          </div>
          <ClearFilter onClear={handleClearFilters} />
        </div>
        <div className="department-grid">
          <div className="loading-message">Loading departments...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="all-departments">
        <h1>All Departments</h1>
        <p>Explore courses by department to enhance your skills in specific areas.</p>
        <div className="search-filters-container">
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search departments..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
          <div className="course-search-bar">
            <input
              type="text"
              placeholder="Search courses..."
              value={courseSearchQuery}
              onChange={handleCourseSearchChange}
            />
          </div>
          <ClearFilter onClear={handleClearFilters} />
        </div>
        <div className="department-grid">
          <div className="error-message">Error loading departments: {error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="all-departments">
      <h1>All Departments</h1>
      <p>Explore courses by department to enhance your skills in specific areas.</p>
      <div className="search-filters-container">
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search departments..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
        <div className="course-search-bar">
          <input
            type="text"
            placeholder="Search courses..."
            value={courseSearchQuery}
            onChange={handleCourseSearchChange}
          />
        </div>
        <ClearFilter onClear={handleClearFilters} />
      </div>
      <div className="department-grid">
        {searchQuery || courseSearchQuery ? (
          // Show course results if course search is active
          courseSearchQuery && filteredCourses.length > 0 ? (
            <div className="courses-results-container">
              <h3>Courses matching "{courseSearchQuery}":</h3>
              <div className="courses-grid">
                {filteredCourses.map((course) => (
                  <div className="course-card-item" key={getCourseId(course)}>
                    <img
                      src={getCourseImage(course.image)}
                      alt={course.title || course.course_title}
                      className="course-card-image"
                    />
                    <div className="course-card-info">
                      <span className="course-card-category">{course.category}</span>
                      <span className="course-card-level">{course.level}</span>
                    </div>
                    <h3 className="course-card-title">{course.title || course.course_title}</h3>
                    <div className="course-card-details">
                      <span className="course-card-videos">🎥 Videos: {course.vc}</span>
                      <span className="course-card-duration">⏱ Duration: {course.td}</span>
                    </div>
                    <div className="course-card-enroll-section">
                      {!enrolledCourses.includes(getCourseId(course)) ? (
                        <button
                          className="course-card-enroll-btn"
                          onClick={() => handleEnroll(getCourseId(course))}
                        >
                          Enroll Now
                        </button>
                      ) : (
                        <>
                          <Link
                            to="/course-videos"
                            state={{
                              department: course.department || course.department_name,
                              courseId: getCourseId(course),
                              courseTitle: course.title || course.course_title
                            }}
                            className="course-card-continue-btn"
                          >
                            Continue
                          </Link>
                          <button
                            className="course-card-unenroll-btn"
                            onClick={() => handleUnenroll(course)}
                          >
                            Unenroll
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : courseSearchQuery ? (
            <div className="no-results">
              <p>No courses found matching "{courseSearchQuery}"</p>
            </div>
          ) : null
        ) : null}
        {!courseSearchQuery && filteredDepartments.map((dept) => (
          <div className="department-card" key={dept.id}>
            <img src={dept.image} alt={dept.name} className="department-image" />
            <div className="card-header" style={{ backgroundColor: dept.color }}>
              <span>{dept.courses} Courses</span>
            </div>
            <div className="card-body">
              <h3>{dept.name}</h3>
              <p>{dept.description}</p>
              <Link to={`/departments/${dept.name}`} className="explore-link">Explore →</Link>
            </div>
          </div>
        ))}
        {!courseSearchQuery && filteredDepartments.length === 0 && searchQuery && (
          <div className="no-results">
            <p>No departments found matching "{searchQuery}"</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllDepartments;